/* tslint:disable */
/* eslint-disable */
/**
 * channels-com
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import { Cart, CartFromJSON, CartFromJSONTyped, CartToJSON } from './';

/**
 *
 * @export
 * @interface CartResponse
 */
export interface CartResponse {
  /**
   *
   * @type {string}
   * @memberof CartResponse
   */
  message: string;
  /**
   *
   * @type {Cart}
   * @memberof CartResponse
   */
  cart: Cart;
}

export function CartResponseFromJSON(json: any): CartResponse {
  return CartResponseFromJSONTyped(json, false);
}

export function CartResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CartResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    message: json['message'],
    cart: CartFromJSON(json['cart']),
  };
}

export function CartResponseToJSON(value?: CartResponse | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    message: value.message,
    cart: CartToJSON(value.cart),
  };
}
